var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "py-5 features-section", attrs: { id: "features" } },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "h2",
          { staticClass: "text-center mb-5 d-none d-lg-block scroll-reveal" },
          [_vm._v("盒子特色")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "feature-tabs-container d-none d-lg-block scroll-reveal",
          },
          [
            _c(
              "div",
              { staticClass: "feature-tabs" },
              _vm._l(_vm.featureData, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    class: [
                      "feature-tab",
                      "animated-tab",
                      { active: _vm.activeTab === index },
                    ],
                    style: { animationDelay: `${index * 0.1}s` },
                    on: {
                      click: function ($event) {
                        return _vm.switchTab(index)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "feature-tab-inner" }, [
                      _c("div", { staticClass: "feature-text-container" }, [
                        _c("div", { staticClass: "feature-text" }, [
                          _vm._v(_vm._s(item.title)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "feature-desc" }, [
                          _vm._v(_vm._s(item.describe)),
                        ]),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mobile-feature-tabs d-lg-none scroll-reveal" },
          _vm._l(_vm.featureData, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                class: [
                  "mobile-feature-tab",
                  "animated-mobile-tab",
                  { active: _vm.activeTab === index },
                ],
                style: { animationDelay: `${index * 0.1}s` },
                on: {
                  click: function ($event) {
                    return _vm.switchTab(index)
                  },
                },
              },
              [
                _c("div", { staticClass: "mobile-feature-text" }, [
                  _vm._v(_vm._s(item.title)),
                ]),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "tab-content feature-content scroll-reveal d-none d-lg-block",
          },
          _vm._l(_vm.featureData, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                class: [
                  "tab-pane",
                  "fade",
                  { "show active": _vm.activeTab === index },
                ],
                attrs: { id: `tab${index + 1}` },
              },
              [
                _c("div", { staticClass: "feature-detail" }, [
                  _c("div", { staticClass: "feature-image animated-image" }, [
                    item.file_type == 2
                      ? _c(
                          "video",
                          {
                            attrs: {
                              src: item.file,
                              autoplay: "",
                              muted: "",
                              controls: "",
                            },
                            domProps: { muted: true },
                            on: {
                              ended: _vm.onVideoEnded,
                              loadeddata: _vm.onVideoLoaded,
                            },
                          },
                          [
                            _vm._v(
                              "\n              您的浏览器不支持视频播放\n            "
                            ),
                          ]
                        )
                      : _c("img", {
                          attrs: { src: item.file, alt: item.title },
                          on: { load: _vm.onImageLoaded },
                        }),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "mobileCarousel",
            staticClass: "mobile-carousel-container d-lg-none scroll-reveal",
            on: {
              touchstart: _vm.handleTouchStart,
              touchmove: _vm.handleTouchMove,
              touchend: _vm.handleTouchEnd,
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "mobile-carousel-wrapper",
                style: {
                  transform: _vm.carouselTransform,
                  width: `${(_vm.featureData.length + 2) * 100}%`,
                  transition: _vm.isTransitioning
                    ? "none"
                    : "transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                },
              },
              [
                _vm.featureData.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "mobile-carousel-slide",
                        style: {
                          width: `${100 / (_vm.featureData.length + 2)}%`,
                        },
                      },
                      [
                        _c("div", { staticClass: "mobile-feature-describe" }, [
                          _vm._v(
                            _vm._s(
                              _vm.featureData[_vm.featureData.length - 1]
                                .describe
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mobile-feature-detail" }, [
                          _c("div", { staticClass: "mobile-feature-image" }, [
                            _vm.featureData[_vm.featureData.length - 1]
                              .file_type == 2
                              ? _c(
                                  "video",
                                  {
                                    attrs: {
                                      src: _vm.featureData[
                                        _vm.featureData.length - 1
                                      ].file,
                                      autoplay: "",
                                      muted: "",
                                      controls: "",
                                    },
                                    domProps: { muted: true },
                                    on: {
                                      ended: _vm.onVideoEnded,
                                      loadeddata: _vm.onVideoLoaded,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                您的浏览器不支持视频播放\n              "
                                    ),
                                  ]
                                )
                              : _c("img", {
                                  attrs: {
                                    src: _vm.featureData[
                                      _vm.featureData.length - 1
                                    ].file,
                                    alt: _vm.featureData[
                                      _vm.featureData.length - 1
                                    ].title,
                                  },
                                  on: { load: _vm.onImageLoaded },
                                }),
                          ]),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.featureData, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: `original-${index}`,
                      staticClass: "mobile-carousel-slide",
                      style: {
                        width: `${100 / (_vm.featureData.length + 2)}%`,
                      },
                    },
                    [
                      _c("div", { staticClass: "mobile-feature-describe" }, [
                        _vm._v(_vm._s(item.describe)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mobile-feature-detail" }, [
                        _c("div", { staticClass: "mobile-feature-image" }, [
                          item.file_type == 2
                            ? _c(
                                "video",
                                {
                                  attrs: {
                                    src: item.file,
                                    autoplay: "",
                                    muted: "",
                                    controls: "",
                                  },
                                  domProps: { muted: true },
                                  on: {
                                    ended: _vm.onVideoEnded,
                                    loadeddata: _vm.onVideoLoaded,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                您的浏览器不支持视频播放\n              "
                                  ),
                                ]
                              )
                            : _c("img", {
                                attrs: { src: item.file, alt: item.title },
                                on: { load: _vm.onImageLoaded },
                              }),
                        ]),
                      ]),
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.featureData.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "mobile-carousel-slide",
                        style: {
                          width: `${100 / (_vm.featureData.length + 2)}%`,
                        },
                      },
                      [
                        _c("div", { staticClass: "mobile-feature-describe" }, [
                          _vm._v(_vm._s(_vm.featureData[0].describe)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mobile-feature-detail" }, [
                          _c("div", { staticClass: "mobile-feature-image" }, [
                            _vm.featureData[0].file_type == 2
                              ? _c(
                                  "video",
                                  {
                                    attrs: {
                                      src: _vm.featureData[0].file,
                                      autoplay: "",
                                      muted: "",
                                      controls: "",
                                    },
                                    domProps: { muted: true },
                                    on: {
                                      ended: _vm.onVideoEnded,
                                      loadeddata: _vm.onVideoLoaded,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                您的浏览器不支持视频播放\n              "
                                    ),
                                  ]
                                )
                              : _c("img", {
                                  attrs: {
                                    src: _vm.featureData[0].file,
                                    alt: _vm.featureData[0].title,
                                  },
                                  on: { load: _vm.onImageLoaded },
                                }),
                          ]),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ],
              2
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }